import * as React from 'react';
import { compose, setDisplayName } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';

export type OwnProps = {
    type: 'Bar' | 'Line';
    checked: boolean;
    onChange: React.ChangeEventHandler<HTMLInputElement>;
};

const RawGraphTypeOption = ({ type, checked, onChange, t }: OwnProps & TranslateProps) =>
    <div>
        <input
            id={ `edit-report-graph-type-${type}` }
            type="radio"
            checked={ checked }
            value={ type }
            onChange={ onChange }
        />
        <label
            htmlFor={ `edit-report-graph-type-${type}` }
        >
            { t(type === 'Line' ? '6.1241.0.43' : '6.1241.0.44') }
        </label>
    </div>
;

export const GraphTypeOption = compose<OwnProps & TranslateProps, OwnProps>(
    setDisplayName('GraphTypeOption'),
    translate(),
)(RawGraphTypeOption);




// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/graph/GraphTypeOption.tsx